import React from "react";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import jssVariables from "../../../jss_setup";
import { Placeholder } from "rsuite";
import { DateTime } from "luxon";
import { useContext } from "react";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";

export const productTypes = {
  ACC: "accommodation",
  FL: "flights",
  TRF: "transfers",
  ACT: "activities",
  MI: "tours",
  FER: "ferries",
  TRA: "trains",
};

export const dater = (dt) =>
  DateTime.fromISO(dt).toLocaleString(DateTime.DATE_MED);
export const dt_dater = (dt) =>
  DateTime.fromISO(dt).toLocaleString(DateTime.DATETIME_FULL);

const loaderMobileStyles = createUseStyles({
  LoaderMobile: (props) => ({
    paddingBottom: jssVariables.half_gap,
    ..._.get(props, "customStyles.LoaderMobile", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const LoaderMobile = () => {
  const classes = loaderMobileStyles({});
  return (
    <div className={classes.LoaderMobile}>
      {new Array(3).fill(1).map((x, idx) => (
        <div className={classes.attribute} key={idx}>
          <Placeholder.Paragraph rows={2} active />
        </div>
      ))}
    </div>
  );
};
LoaderMobile.defaultProps = {};
LoaderMobile.propTypes = {};

const loaderDesktopStyles = createUseStyles({
  LoaderDesktop: (props) => ({
    ..._.get(props, "customStyles.LoaderDesktop", {}),
  }),
  table: (props) => ({
    width: "100%",
    "& td:not(:first-child)": {
      borderLeft: "1px solid #cccccc",
    },
    "& th": {
      padding: jssVariables.half_gap,
    },
    "& td": {
      padding: [jssVariables.half_gap, jssVariables.normal_gap],
      color: jssVariables.colors.text.dark,
    },
    ..._.get(props, "customStyles.table", {}),
  }),
  thead: (props) => ({
    background: "#F7F7F7",
    textTransform: "capitalize",
    fontWeight: 500,
    color: jssVariables.colors.base_color,
    padding: jssVariables.half_gap,
    ..._.get(props, "customStyles.thead", {}),
  }),
  placeholderParagraphHeader: (props) => ({
    paddingBottom: jssVariables.half_gap,
    ..._.get(props, "customStyles.placeholderParagraphHeader", {}),
  }),
  placeholderGraph: (props) => ({
    width: "7rem",
    height: `${jssVariables.double_gap}!important`,
    borderRadius: jssVariables.half_gap,
    ..._.get(props, "customStyles.placeholderGraph", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const LoaderDesktop = () => {
  const classes = loaderDesktopStyles({});

  return (
    <div className={classes.LoaderDesktop}>
      <table className={classes.table}>
        <thead className={classes.thead}>
          <tr>
            {new Array(4).fill(1).map((x, idx) => (
              <th key={idx}>
                <Placeholder.Paragraph
                  rows={1}
                  active
                  className={classes.placeholderParagraphHeader}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {new Array(3).fill(1).map((x, idx) => (
            <tr key={idx}>
              <td style={{ width: "7rem" }}>
                <Placeholder.Paragraph rows={2} active />
              </td>
              <td style={{ width: "20rem" }}>
                <Placeholder.Paragraph rows={2} active />
              </td>
              <td style={{ width: "7rem" }}>
                <Placeholder.Paragraph rows={2} active />
              </td>
              <td style={{ width: "7rem" }}>
                <Placeholder.Graph
                  active
                  className={classes.placeholderGraph}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = createUseStyles({
  NoReservations: (props) => ({
    fontSize: "large",
    ..._.get(props, "customStyles.NoReservations", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const NoReservations = () => {
  const { t } = useContext(TranslationContext);
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = styles({
    customStyles: cStyler({
      type,
      brand,
      objName: "NoReservations",
    }),
  });

  return (
    <div className={classes.NoReservations}>
      {t("noReservationsOfThisProduct")}.
    </div>
  );
};
NoReservations.defaultProps = {};
NoReservations.propTypes = {};
